export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";